export const toggleMultiSelect = (selected: string[], value: string) =>
  selected.includes(value)
    ? selected.filter((item) => item !== value)
    : [...selected, value];
